<template>
  <div>
    <AuctionFormLabeledSlider
      :value="dutchSteps"
      label="Dutch Steps"
      tooltip="Dutch steps in Insider Auction ( 1 step = 1 % )"
      :min="1"
      :max="99"
      :thumb-size="30"
      :layout-style="{ marginTop: '40px' }"
      label-sm-down-mb
      @step-in="$emit('dutch-steps-in')"
      @step-out="$emit('dutch-steps-out')"
      @input="$emit('update:dutchSteps', $event)"
    >
      <template v-slot:thumb-label="props">
        <div style="font-size: 11px">{{ props.value }}%</div>
      </template>
      <span v-if="value && dutchSteps" class="placeholder" style="color: #000">
        The initial price may decrease to <strong>{{ endPricePreview }} {{ currency }}</strong>
      </span>
      <span v-if="errDutchRequired" class="error-input">This field is required</span>
      <span v-if="errDutchMin" class="error-input">Steps must be equal or more then 1</span>
      <span v-if="errDutchMax" class="error-input">Steps must be equal or less then 99</span>
    </AuctionFormLabeledSlider>

    <AuctionFormLabeledSlider
      :value="timeOfOneStep"
      label="Step Duration"
      tooltip="Time of one step"
      :min="0.5"
      :max="5"
      :step="0.5"
      :thumb-size="40"
      :layout-style="{ marginTop: '50px', marginBottom: '40px' }"
      label-sm-down-mb
      no-gutters-on-label
      @step-in="$emit('time-step-in')"
      @step-out="$emit('time-step-out')"
      @input="$emit('update:timeOfOneStep', $event)"
    >
      <template v-slot:thumb-label="props">
        <div style="font-size: 11px">{{ props.value }}min</div>
      </template>
      <span v-if="timeOfOneStep && dutchSteps" class="placeholder" style="color: #000">
        Dutch period in Insider Auction will be <strong>{{ dutchPeriodMinutes }} minutes</strong>
      </span>
      <span v-if="errTimeRequired" class="error-input">This field is required</span>
      <span v-if="errTimeMin" class="error-input"
        >Time of one step must be equal or more then 0.5 min</span
      >
      <span v-if="errTimeMax" class="error-input"
        >Time of the step must be equal or less then 5</span
      >
    </AuctionFormLabeledSlider>
  </div>
</template>

<script>
import AuctionFormLabeledSlider from './AuctionFormLabeledSlider.vue';
import { formatDisplayNumber } from '@/utils/numberFormat';

export default {
  name: 'AuctionFormInsiderDutch',
  components: { AuctionFormLabeledSlider },
  props: {
    value: { type: Number, required: true },
    currency: { type: String, required: true },
    dutchSteps: { type: Number, required: true },
    timeOfOneStep: { type: Number, required: true },
    errDutchRequired: { type: Boolean, default: false },
    errDutchMin: { type: Boolean, default: false },
    errDutchMax: { type: Boolean, default: false },
    errTimeRequired: { type: Boolean, default: false },
    errTimeMin: { type: Boolean, default: false },
    errTimeMax: { type: Boolean, default: false },
  },
  computed: {
    endPricePreview() {
      const preview = this.value - (this.value * this.dutchSteps) / 100;
      return formatDisplayNumber(preview);
    },
    dutchPeriodMinutes() {
      return this.dutchSteps * this.timeOfOneStep + this.timeOfOneStep;
    },
  },
};
</script>
